var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('v-alert',{staticClass:"mr-1 ml-1",attrs:{"dense":"","color":"red","elevation":"5","outlined":"","text":"","type":"error","align":"center"}},[_vm._v(" "+_vm._s(_vm.alertValidate))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }